<fieldset>
  <legend class="h1">Port authority</legend>
  <fieldset class="mb-3">
    <legend class="h5">Clearances</legend>
    <div class="row">
      <app-operational-clearance-field
        class="col-4"
        [clearanceGroup]="$any(form.control.get('portAuthority').get('clearances').get('ekh'))"
        label="Visit"
        clearanceKey="ekh"
        [statusOptions]="clearanceStatusOptions"
        [formatterTemplate]="clearanceRt">
      </app-operational-clearance-field>
      <app-operational-clearance-field
        class="col-4"
        [clearanceGroup]="$any(form.control.get('portAuthority').get('clearances').get('mdoh'))"
        label="Health"
        clearanceKey="mdoh"
        [statusOptions]="clearanceStatusOptions"
        [formatterTemplate]="clearanceRt">
      </app-operational-clearance-field>
      <app-operational-clearance-field
        class="col-4"
        [clearanceGroup]="$any(form.control.get('portAuthority').get('clearances').get('sspi'))"
        label="Security"
        clearanceKey="sspi"
        [statusOptions]="clearanceStatusOptions"
        [formatterTemplate]="clearanceRt">
      </app-operational-clearance-field>
      <app-operational-clearance-field
        class="col-4 mt-4"
        [clearanceGroup]="$any(form.control.get('portAuthority').get('clearances').get('emas'))"
        label="Waste"
        clearanceKey="emas"
        [statusOptions]="clearanceStatusOptions"
        [formatterTemplate]="clearanceRt">
      </app-operational-clearance-field>
      <app-operational-clearance-field
        class="col-4 mt-4"
        [clearanceGroup]="$any(form.control.get('portAuthority').get('clearances').get('emgs'))"
        label="Dangerous goods"
        clearanceKey="emgs"
        [statusOptions]="clearanceStatusOptions"
        [formatterTemplate]="clearanceRt">
      </app-operational-clearance-field>
    </div>
  </fieldset>
  <fieldset class="mb-3">
    @if (isIncomingTrip() && !isPilotOnly()) {
    <app-form-field label="Operational Contact" [includeMargin]="false">
      <app-radio [formControl]="$any(form.control.get('portAuthority').get('operationalContact'))"
                [inline]="true"
                [options]="booleanOptions"
                [formatter]="booleanFormatter"
                [required]="true"></app-radio>
    </app-form-field>
    }
    @if (showVesselDraft()) {
      <fieldset class="card mt-2">
        <div class="card-body p-4 pb-2 pt-3">
          @if (!isPilotOnly()) {
          <app-form-field label="Current vessel draft">
            <div class="input-group">
              <input [ngModel]="currentVesselDraught()"
                    id="current-vessel-draft"
                    appDecimalNumber [maxDecimals]="2"
                    [readonly]="true"
                    class="form-control">
              <span class="input-group-text">m</span>
            </div>
          </app-form-field>
          }
          <app-form-field label="Actual vessel draft">
            <div class="input-group">
              <input #actualVesselDraft
                    [ngModel]="form.control.get('portAuthority')?.get('actualVesselDraft')?.value"
                    (ngModelChange)="actualVesselDraftChanged($event)"
                    id="actual-vessel-draft"
                    appDecimalNumber [maxDecimals]="2"
                    [attr.max]="maxVesselDraught()"
                    class="form-control"
                    [class.is-invalid]="actualVesselDraft.validity.rangeOverflow">
              <span class="input-group-text">m</span>
            </div>
            @if (actualVesselDraft.validity.rangeOverflow) {
              <div class="invalid-feedback d-block">
                Actual vessel draft ({{actualVesselDraft.value}}m) cannot exceed the vessel's maximum draught ({{maxVesselDraught()}}m)
              </div>
            }
          </app-form-field>
        </div>
      </fieldset>
    }
  </fieldset>
  @if (!isPilotOnly()) {
  <fieldset class="mb-3">
    <app-form-field label="Tidal window" [includeMargin]="false">
      <app-radio [formControl]="$any(form.control.get('portAuthority').get('tidalWindow'))"
                [inline]="true"
                [options]="booleanOptions"
                [formatter]="booleanFormatter"
                [required]="true"></app-radio>
    </app-form-field>
    @if (portAuthorityValues()?.tidalWindow) {
      <fieldset class="card mt-2">
        <div class="card-body p-4 pb-2 pt-3">
          <app-form-field label="Tidal window start">
            <app-date-field [formControl]="$any(form.control.get('portAuthority').get('tidalWindowStart'))"
                            [required]="true"></app-date-field>
          </app-form-field>
          <app-form-field label="Tidal window end">
            <app-date-field [formControl]="$any(form.control.get('portAuthority').get('tidalWindowEnd'))"
                            [required]="true"></app-date-field>
          </app-form-field>
        </div>
      </fieldset>
    }
  </fieldset>
  }
  <fieldset class="mb-3">
    <app-form-field label="Shore based pilotage" [includeMargin]="false">
      <app-radio [formControl]="$any(form.control.get('portAuthority').get('pilotFromDistance'))"
                [inline]="true"
                [options]="booleanOptions"
                [formatter]="booleanFormatter"
                [required]="true"></app-radio>
    </app-form-field>
    @if (portAuthorityValues()?.pilotFromDistance) {
      <fieldset class="card mt-2">
        <div class="card-body p-4 pb-2 pt-3">
          <app-form-field label="Shore based pilotage approved by Port authority">
            <app-radio [formControl]="$any(form.control.get('portAuthority').get('pilotFromDistanceAccepted'))"
                      [inline]="true"
                      [options]="booleanOptions"
                      [formatter]="booleanFormatter">
            </app-radio>
          </app-form-field>
        </div>
      </fieldset>
    }
  </fieldset>
  @if (!isPilotOnly()) {
  <fieldset>
    <app-form-field label="On hold" [includeMargin]="false">
      <app-radio [formControl]="$any(form.control.get('portAuthority').get('onHold'))"
                [inline]="true"
                [options]="booleanOptions"
                [formatter]="booleanFormatter"
                [required]="true"></app-radio>
    </app-form-field>
    @if (portAuthorityValues()?.onHold) {
      <fieldset class="card mt-2">
        <div class="card-body p-4 pb-2 pt-3">
          <app-form-field label="On hold date">
            <app-date-field [formControl]="$any(form.control.get('portAuthority').get('onHoldDate'))"
                            [required]="true"></app-date-field>
          </app-form-field>
        </div>
      </fieldset>
    }
  </fieldset>
  }
</fieldset>
<ng-template #clearanceRt let-status="result">
  <app-task-message-status [messageStatus]="clearanceToMessageStatus(status)" [showTooltip]="false"/>
</ng-template>
